import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { getDateFormattedWithTime } from 'utilities/dates_and_times';
import { getAnnotationsByProvider } from 'components/OrderDetails/Tabs/utilities';
import React from 'react';

export const BatchUploadTable = ({ classes, slides, uploadedAnnotations }) => (
  <TableContainer
    component={Paper}
    className={classes.annotationTableContainer}
  >
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Slide Name</TableCell>
          <TableCell>Created</TableCell>
          <TableCell align="right">Annotations Uploaded</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {slides.map((slide) => (
          <TableRow key={slide.uuid}>
            <TableCell component="th" scope="row">
              {slide.name}
            </TableCell>
            <TableCell scope="row">
              {getDateFormattedWithTime(slide.created)}
            </TableCell>
            <TableCell align="right" className={classes.providersCell}>
              {getAnnotationsByProvider(slide, uploadedAnnotations).map(
                (provider) => (
                  <Box
                    key={provider.name}
                    className={classes.providerIconContainer}
                  >
                    <img
                      src={provider.icon}
                      alt={provider.name}
                      className={classes.providerIcon}
                    />
                    {provider.count > 1 && (
                      <Box className={classes.providerIconBubble}>
                        {provider.count}
                      </Box>
                    )}
                  </Box>
                ),
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
